export default __webpack_public_path__ + "static/media/verify-email-illustration-dark.fac3bd3e.svg";